import { apiFetch } from "./apiFetch";

let cache = new Map();
let inFlight = new Map();
const CACHE_DURATION = 3000; // 3s

export const getProfile = async () => {
  try {
    const key = "profile_me";
    const now = Date.now();


    if (cache.has(key)) {
      const cached = cache.get(key);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }

    if (inFlight.has(key)) {
      return inFlight.get(key);
    }

    const promise = (async () => {
      try {
        const response = await apiFetch("/utilizadores/me");

        if (!response.ok) {
          throw new Error(`Erro na API: ${response.status}`);
        }

        const data = await response.json();

        cache.set(key, {
          data,
          time: Date.now(),
        });

        return data;
      } finally {
        inFlight.delete(key);
      }
    })();

    inFlight.set(key, promise);
    return promise;

  } catch (error) {
    console.error("Erro ao buscar perfil:", error);
    return null;
  }
};